import { ScrollView, StyleSheet, View } from 'react-native';
import { Surface, Text, useTheme, Button } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'expo-router';
import { useState } from 'react';

export default function DeleteAccount() {
  const { t } = useTranslation();
  const theme = useTheme();
  const router = useRouter();
  const [requestSent, setRequestSent] = useState(false);

  const handleDeleteRequest = () => {
    // In a real implementation, this would trigger an API call to submit the deletion request
    // For now, we'll just simulate the success
    setRequestSent(true);
  };

  return (
    <Surface style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <Text style={[styles.title, { color: theme.colors.primary }]}>Solicitar Eliminação de Conta AllDrivers</Text>
        
        {requestSent ? (
          <View style={styles.successMessage}>
            <Text style={styles.successText}>
              A sua solicitação foi recebida. Entraremos em contacto consigo em breve para confirmar a eliminação da sua conta.
            </Text>
            <Button 
              mode="contained" 
              onPress={() => router.push('/')}
              style={styles.backButton}
            >
              Voltar ao Início
            </Button>
          </View>
        ) : (
          <>
            <Text style={styles.paragraph}>
              Na AllDrivers, valorizamos a sua privacidade e o controlo sobre os seus dados pessoais. Esta página explica como pode solicitar a eliminação da sua conta e informações associadas do nosso sistema.
            </Text>

            <Text style={styles.sectionTitle}>Processo de Eliminação de Conta</Text>
            <Text style={styles.paragraph}>
              Para eliminar a sua conta e os dados associados da plataforma AllDrivers, siga um dos seguintes métodos:
            </Text>

            <Text style={styles.subSectionTitle}>Método 1: A partir da Aplicação</Text>
            <Text style={styles.paragraph}>
              1. Aceda à sua conta na aplicação AllDrivers
            </Text>
            <Text style={styles.paragraph}>
              2. Navegue até "Configurações" {`>`} "Conta"
            </Text>
            <Text style={styles.paragraph}>
              3. Clique em "Eliminar Conta" na parte inferior da página
            </Text>
            <Text style={styles.paragraph}>
              4. Confirme a sua decisão seguindo as instruções apresentadas
            </Text>

            <Text style={styles.subSectionTitle}>Método 2: Enviar E-mail Diretamente</Text>
            <Text style={styles.paragraph}>
              Envie um pedido diretamente para o nosso e-mail de apoio ao cliente em privacidade@alldrivers.pt com o assunto "Solicitação de Eliminação de Conta" incluindo:
            </Text>
            <Text style={styles.paragraph}>
              • O endereço de e-mail associado à sua conta
            </Text>
            <Text style={styles.paragraph}>
              • O seu nome completo
            </Text>
            <Text style={styles.paragraph}>
              • Motivo da eliminação (opcional)
            </Text>

            <Text style={styles.subSectionTitle}>Método 3: Utilizar Este Formulário Online</Text>
            <Text style={styles.paragraph}>
              Clique no botão abaixo para enviar uma solicitação direta de eliminação de conta. Entraremos em contacto consigo no e-mail associado à sua conta para confirmar a solicitação.
            </Text>

            <Button 
              mode="contained" 
              onPress={handleDeleteRequest} 
              style={styles.deleteButton}
            >
              Solicitar Eliminação de Conta
            </Button>

            <Text style={styles.sectionTitle}>Dados Eliminados</Text>
            <Text style={styles.paragraph}>
              Quando a sua conta é eliminada, os seguintes dados serão permanentemente removidos dos nossos sistemas ativos:
            </Text>
            <Text style={styles.paragraph}>
              • Informações pessoais (nome, e-mail, número de telefone)
            </Text>
            <Text style={styles.paragraph}>
              • Dados de perfil e preferências
            </Text>
            <Text style={styles.paragraph}>
              • Fotos de perfil
            </Text>
            <Text style={styles.paragraph}>
              • Histórico de atividades
            </Text>
            <Text style={styles.paragraph}>
              • Informações de veículos registados
            </Text>

            <Text style={styles.sectionTitle}>Dados Retidos</Text>
            <Text style={styles.paragraph}>
              Por obrigações legais e comerciais, alguns dados podem ser retidos após a eliminação da sua conta:
            </Text>
            <Text style={styles.paragraph}>
              • Registos de transações e faturação (retidos por 7 anos, conforme exigido pela legislação fiscal)
            </Text>
            <Text style={styles.paragraph}>
              • Registos de utilização agregados e anónimos para análise estatística
            </Text>
            <Text style={styles.paragraph}>
              • Comunicações com o apoio ao cliente (retidas por 2 anos)
            </Text>

            <Text style={styles.sectionTitle}>Tempo de Processamento</Text>
            <Text style={styles.paragraph}>
              • A sua solicitação será processada num prazo de 30 dias
            </Text>
            <Text style={styles.paragraph}>
              • Você receberá uma confirmação por e-mail quando a eliminação estiver concluída
            </Text>
            <Text style={styles.paragraph}>
              • Os dados em cópias de segurança podem levar até 90 dias para serem completamente eliminados dos nossos sistemas
            </Text>

            <Text style={styles.sectionTitle}>Contacte-nos</Text>
            <Text style={styles.paragraph}>
              Se tiver dúvidas sobre o processo de eliminação de conta, contacte-nos em:
            </Text>
            <Text style={styles.paragraph}>
              • E-mail: privacidade@alldrivers.pt
            </Text>
          </>
        )}
      </ScrollView>
    </Surface>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollContainer: {
    padding: 20,
    paddingBottom: 40,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 24,
    marginBottom: 10,
  },
  subSectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 16,
    marginBottom: 8,
  },
  paragraph: {
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 8,
  },
  deleteButton: {
    marginTop: 20,
    marginBottom: 20,
    alignSelf: 'center',
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  successMessage: {
    marginTop: 20,
    padding: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  successText: {
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
    marginBottom: 20,
  },
  backButton: {
    marginTop: 10,
  },
}); 